// @mui
import { Stack, Typography, Box } from '@mui/material';
// auth
import { useAuth, useI18n } from 'iomart-hooks';

// ----------------------------------------------------------------------

export default function NavDocs() {
  const { displayName } = useAuth();

  const { t } = useI18n(false);

  return (
    <Stack
      spacing={3}
      sx={{
        px: 5,
        pb: 5,
        mt: 10,
        width: 1,
        display: 'block',
        textAlign: 'center',
      }}
    >
      <Box component="img" src="/assets/illustrations/illustration_docs.svg" />

      <div>
        <Typography gutterBottom variant="subtitle1">
          {`${t('Hi')}, ${displayName}`}
        </Typography>
      </div>
    </Stack>
  );
}
